import React, {useState,  useEffect} from "react";
import { Button, Grid, Tooltip } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import{IconDown, IconDownInvert} from '../static/DimIcons'

import CircularProgress from '@material-ui/core/CircularProgress';

import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import AddIcon from '@material-ui/icons/Add';
import AppsIcon from '@material-ui/icons/Apps';
import Popover from '@material-ui/core/Popover';


const useStyles = makeStyles(theme => ({
  root: {
    box: {
      height: 50,
      display: "flex",
      padding: 5
    },
    centerBox: {
      height: 50,
      justifyContent: "flex-end",
      alignItems: "flex-end"
    }
  },
  largeIcon: {
    width: 55,
    height: 60,
  },
  paper: {
    padding: theme.spacing(1),
    color: "white",
    fontSize: '.75rem',
    textAlign: 'center',
    overflow: 'hidden',
  },
  button: {
    height: 95, // setting height/width is optional
  },
  label: {
    // Aligns the content of the button vertically.
    flexDirection: 'column'
  },
  buttonDownloads: {
    style: {
    margin: '5%',
    maxWidth: "105px",
    maxHeight: "250px",
    minWidth: "125px",
    minHeight: "125px",
    fontSize: '.75rem',
    textAlign: 'center',
    borderRadius: 100,
    }
  }


  
}));



export  function DownloadButton(props) {
  const {  setDownload, spinner, setLimitDowload } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [downloadStart, setDownloadStart] = useState(false);
  const [downloadFinished, setDownloadFinished] = useState(true);

  const classes = useStyles();
  


  
  var timeoutStartSpinner = () => {setTimeout(() => {setDownloadStart(true) }, [5000]);}
  var timeoutFinish = () => {setTimeout(() => {setDownloadFinished(true) }, [3000]);}

  const Downloading =  <label>Prepping Download</label>
  const DownloadingNow =  <label>Download Complete</label>

  const downloadScreenshot = ( ) => {
    
    setDownload(true)
    timeoutStartSpinner()

  }

  useEffect(()=>{
    
    if (spinner === true){
      setSpinnerStatus(true)
      setDownloadFinished(false)
    }else if(spinner === false && spinnerStatus === true){
      setSpinnerStatus(false)
      setDownloadStart(false)
      timeoutFinish()
    };


  }, [spinner, spinnerStatus])


  const onClick = (event ) => {
    handlePopoverOpen(event)
  };

  function hover() { setIsHovered(true) }
  function left() { setIsHovered(false) }

   // -------- popover

   const [anchorEl, setAnchorEl] = useState(null);
   const [downloadState, setDownloadState] = useState(false);


 
   const handlePopoverOpen = (event) => {
     setAnchorEl(event.currentTarget);


   };
 
   const handlePopoverClose = () => {
     setAnchorEl(null);
   };
 
   const open = Boolean(anchorEl);
   
  
 
  //  const handleOnClick = () => {
  //   handlePopoverOpen()
  //  }
   const handleOnClickPDF = () => {

    setDownloadState(true)
    setLimitDowload(true)

    downloadScreenshot()
    handlePopoverClose()
   }
   const handleOnClickAll = () => {
    setDownloadState(true)
    downloadScreenshot()
    handlePopoverClose()
   }

   
   
  return (

    <div >
      <div className={classes.root}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        id={downloadState ? 'mask' : 'noMask'}
        >
        <Tooltip title={'Click for download options'} arrow>
        <Button variant="outlined" onClick={onClick} onMouseEnter={hover} onMouseLeave={left} > 
          
          {downloadFinished? 
            isHovered ? <IconDownInvert iconStyle={classes.largeIcon}/>  : <IconDown/> 
          :
          spinnerStatus?
            downloadStart? 
              isHovered ?  <CircularProgress disableShrink  
                              variant="indeterminate"
                              sx={{
                                color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
                                animationDuration: '550ms',
                                position: 'absolute',
                                left: 0,
                              }}
                              size={40}
                              thickness={4}
                              
          /> : <CircularProgress disableShrink  
                                variant="indeterminate"
                                sx={{
                                  color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
                                  animationDuration: '550ms',
                                  position: 'absolute',
                                  left: 0,
                                }}
                                size={40}
                                thickness={4}
            
          /> 
            :
            isHovered ? Downloading : Downloading 
          :
          isHovered ? DownloadingNow : DownloadingNow 
          }



        </Button>
      </Tooltip>
      <div >
                  <Popover
                  id="mouse-over-popover"
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handlePopoverClose}

                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    style: { width: '300px',
                    minWidth: '150px',
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  overflow: 'hidden',
                },
                  }}
                >
                  <Grid container  spacing={1}>

                    <Grid item xs={6}  >
                      <Button 
                      classes={{ root: classes.button, label: classes.label,  }}
                      variant="outlined"
                      style={{
                        margin: '5%',
                        maxWidth: "105px",
                        maxHeight: "250px",
                        minWidth: "125px",
                        minHeight: "125px",
                        fontSize: '.75rem',
                        textAlign: 'center',
                        borderRadius: 100,
                        
                      }}
                    
                      onClick={handleOnClickPDF}
                      > 
                      <div>
                      <PictureAsPdf/> 
                      </div>
                      <div>
                        Download PDF Only
                      </div>
                      </Button>
                    </Grid>

                    <Grid item xs={6}  >
                      <Button 
                        classes={{ root: classes.button, label: classes.label, }}
                        variant="outlined"
                        style={{
                          margin: '5%',
                          maxWidth: "105px",
                          maxHeight: "250px",
                          minWidth: "125px",
                          minHeight: "125px",
                          fontSize: '.75rem',
                          textAlign: 'center',
                          borderRadius: 100,
                          
                        }}
                      
                        onClick={handleOnClickAll}
                        > 
                        <div>
                        <PictureAsPdf/> 
                        <AddIcon/> 
                        <AppsIcon/> 

                        </div>
                        <div>
                          Download ALL (44 MB)
                        </div>
                      </Button>
                    </Grid>

                  </Grid>
                </Popover>
              </div>
    </div>
    </div>
    
    )
}